import { DealRegistryPageListDueDiligenceRecordsQuery } from '@/__generated__/graphql';
import { DeleteBucketIcon } from '@/assets/static/icons/delete-bucket';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface DeleteDealProps {
  onClose: () => void;
  isOpen: boolean;
  handleDeleteDeal: (id: string) => void;
  row: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number] | null;
}

const DeleteDeal = ({ onClose, isOpen, handleDeleteDeal, row }: DeleteDealProps) => {
  const saveValue = () => {
    if (!row) return;
    handleDeleteDeal(row.id);
    onClose();
  };

  return (
    <ModalWrappedContent isOpen={isOpen} onClose={onClose} confirmButton={{ name: 'Yes, Delete', onClick: saveValue }}>
      <ModalContainer>
        <DeleteBucketIcon fill={themeVar('font.disabled')} />
        <ModalTitel>Please confirm you want to delete this deal.</ModalTitel>
        <ModalDescription>This deal will be permanently deleted. This action cannot be undone.</ModalDescription>
      </ModalContainer>
    </ModalWrappedContent>
  );
};

export default DeleteDeal;

const ModalContainer = styled.div`
  font-weight: 400;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const ModalTitel = styled.div`
  font-size: 33px;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  color: ${themeVar('font.base')};
`;
